import React from 'react';
import {ListConsumer} from '../../ContextComponents/ListContext/'

const ListHoc = (Wrapped) => {
    return (props) => {
        return (
            <ListConsumer>
                {
                    (screenProps) => {
                        return (
                            <Wrapped {...screenProps} {...props}/>
                        )
                    }
                }
            </ListConsumer>
        )
    }
};
export default ListHoc;